import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Mail } from "lucide-react";
import { Button } from "./ui/button";

const LOGO_URL = "/logo_concept_1.png";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Wholesale", path: "/wholesale" },
  { name: "Flavors", path: "/flavors" },
  { name: "UV Cotton Candy", path: "/uv-cotton-candy" },
  { name: "Live Events", path: "/events" },
  { name: "About", path: "/about" },
];

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const handleNavClick = (path) => {
    setMobileMenuOpen(false);
    if (path.includes("#")) {
      const [basePath, hash] = path.split("#");
      if (location.pathname === basePath || basePath === "/") {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-40 nav-glass shadow-sm" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-testid="nav-logo">
            <img 
              src={LOGO_URL} 
              alt="Cotton Candy Girl" 
              className="h-14 w-auto rounded-lg"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => handleNavClick(link.path)}
                className="px-4 py-2 rounded-full text-[#4A4A4A] hover:text-[#FF9EAA] hover:bg-pink-50 transition-all font-medium text-sm"
                data-testid={`nav-link-${link.name.toLowerCase().replace(" ", "-")}`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Contact Button */}
          <div className="hidden md:flex items-center gap-3">
            <Link to="/contact">
              <Button 
                className="bg-[#FF9EAA] hover:bg-[#FF8FAB] text-white rounded-full px-6 py-2 font-semibold shadow-md hover:shadow-lg transition-all btn-scale"
                data-testid="nav-contact-btn"
              >
                <Mail className="mr-2" size={18} />
                Contact Us
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center gap-2">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-lg text-[#4A4A4A] hover:bg-pink-50 transition-colors"
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-pink-100" data-testid="mobile-menu">
            <div className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  onClick={() => handleNavClick(link.path)}
                  className="px-4 py-3 rounded-xl text-[#4A4A4A] hover:text-[#FF9EAA] hover:bg-pink-50 transition-all font-medium"
                  data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(" ", "-")}`}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
                <Button 
                  className="w-full bg-[#FF9EAA] hover:bg-[#FF8FAB] text-white rounded-full py-3 font-semibold mt-2"
                  data-testid="mobile-contact-btn"
                >
                  <Mail className="mr-2" size={18} />
                  Contact Us
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
